import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { selectAllBillToLocations } from '@user/store/entityLocations/slice'
import { useSelector } from 'react-redux'
import { AddExistingServiceLocationForm } from './AddExistingServiceLocationForm'
import { ENTITY_TYPES } from '@sales-center/common'
import Box from '@mui/material/Box'
import { Theme } from '@mui/material/styles'

interface Props {
  entityType: ENTITY_TYPES
  entityId: number
  onClose: () => void
}

export const AddExistingServiceLocationFormWrapper: React.FC<Props> = (
  props,
) => {
  const billToLocations = useSelector(selectAllBillToLocations)

  return !billToLocations[0] ? (
    <Box
      sx={{
        paddingTop: (theme: Theme) => theme.spacing(4.8),
        textAlign: 'center',
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  ) : (
    <>
      <div>
        <AddExistingServiceLocationForm
          {...props}
          billToLocation={billToLocations[0]}
        />
      </div>
    </>
  )
}
AddExistingServiceLocationFormWrapper.displayName =
  'AddExistingServiceLocationFormWrapper'
